import cn from 'classnames'

import {tg} from '../typography'
import {TButtonParams} from './types'

import styles from './styles.module.css'

export function btn({
  size = 'm',
  stretchToFillContainer = false,
  variant = 'primary',
  shape = 'rounded',
  className,
  isLink = false,
  invertColors = false,
  ...params
}: TButtonParams) {
  return tg({
    className: cn(
      {
        [styles.link]: isLink,
        [styles.stretch]: Boolean(stretchToFillContainer),
        [styles.invert]: invertColors,
      },
      styles.root,
      styles[size],
      styles[variant],
      styles[shape],
      className,
    ),
    ...params,
  })
}
